export var LogLevel;
(function (LogLevel) {
    LogLevel["ERROR"] = "error";
    LogLevel["WARN"] = "warn";
    LogLevel["INFO"] = "info";
    LogLevel["DEBUG"] = "debug";
    LogLevel["TRACE"] = "trace";
})(LogLevel || (LogLevel = {}));
export var LogType;
(function (LogType) {
    LogType["HTTP"] = "HTTP";
    LogType["SERVICE"] = "Service";
    LogType["REPOSITORY"] = "Repository";
    LogType["MIDDLEWARE"] = "Middleware";
    LogType["QUEUE"] = "Queue";
    LogType["DATABASE"] = "Database";
    LogType["CACHE"] = "Cache";
    LogType["STORAGE"] = "Storage";
    LogType["EVENT"] = "Event";
    LogType["ERROR"] = "Error";
    LogType["DEBUG"] = "Debug";
    LogType["TRACE"] = "Trace";
    LogType["INFO"] = "Info";
    LogType["WARN"] = "Warn";
})(LogType || (LogType = {}));
export var LogActionType;
(function (LogActionType) {
    LogActionType["GET"] = "GET";
    LogActionType["POST"] = "POST";
    LogActionType["PUT"] = "PUT";
    LogActionType["PATCH"] = "PATCH";
    LogActionType["DELETE"] = "DELETE";
    LogActionType["AGGREGATE"] = "AGGREGATE";
    LogActionType["ERROR"] = "ERROR";
    LogActionType["DEBUG"] = "DEBUG";
    LogActionType["TRACE"] = "TRACE";
    LogActionType["INFO"] = "INFO";
    LogActionType["WARN"] = "WARN";
})(LogActionType || (LogActionType = {}));
export var LogStatus;
(function (LogStatus) {
    LogStatus["SUCCESS"] = "Success";
    LogStatus["REDIRECT"] = "Redirect";
    LogStatus["FAIL"] = "Fail";
    LogStatus["PENDING"] = "Pending";
})(LogStatus || (LogStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xvZy9Mb2cudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksUUFNWDtBQU5ELFdBQVksUUFBUTtJQUNsQiwyQkFBZSxDQUFBO0lBQ2YseUJBQWEsQ0FBQTtJQUNiLHlCQUFhLENBQUE7SUFDYiwyQkFBZSxDQUFBO0lBQ2YsMkJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBTlcsUUFBUSxLQUFSLFFBQVEsUUFNbkI7QUFDRCxNQUFNLENBQU4sSUFBWSxPQWVYO0FBZkQsV0FBWSxPQUFPO0lBQ2pCLHdCQUFhLENBQUE7SUFDYiw4QkFBbUIsQ0FBQTtJQUNuQixvQ0FBeUIsQ0FBQTtJQUN6QixvQ0FBeUIsQ0FBQTtJQUN6QiwwQkFBZSxDQUFBO0lBQ2YsZ0NBQXFCLENBQUE7SUFDckIsMEJBQWUsQ0FBQTtJQUNmLDhCQUFtQixDQUFBO0lBQ25CLDBCQUFlLENBQUE7SUFDZiwwQkFBZSxDQUFBO0lBQ2YsMEJBQWUsQ0FBQTtJQUNmLDBCQUFlLENBQUE7SUFDZix3QkFBYSxDQUFBO0lBQ2Isd0JBQWEsQ0FBQTtBQUNmLENBQUMsRUFmVyxPQUFPLEtBQVAsT0FBTyxRQWVsQjtBQUNELE1BQU0sQ0FBTixJQUFZLGFBWVg7QUFaRCxXQUFZLGFBQWE7SUFDdkIsNEJBQVcsQ0FBQTtJQUNYLDhCQUFhLENBQUE7SUFDYiw0QkFBVyxDQUFBO0lBQ1gsZ0NBQWUsQ0FBQTtJQUNmLGtDQUFpQixDQUFBO0lBQ2pCLHdDQUF1QixDQUFBO0lBQ3ZCLGdDQUFlLENBQUE7SUFDZixnQ0FBZSxDQUFBO0lBQ2YsZ0NBQWUsQ0FBQTtJQUNmLDhCQUFhLENBQUE7SUFDYiw4QkFBYSxDQUFBO0FBQ2YsQ0FBQyxFQVpXLGFBQWEsS0FBYixhQUFhLFFBWXhCO0FBRUQsTUFBTSxDQUFOLElBQVksU0FLWDtBQUxELFdBQVksU0FBUztJQUNuQixnQ0FBbUIsQ0FBQTtJQUNuQixrQ0FBcUIsQ0FBQTtJQUNyQiwwQkFBYSxDQUFBO0lBQ2IsZ0NBQW1CLENBQUE7QUFDckIsQ0FBQyxFQUxXLFNBQVMsS0FBVCxTQUFTLFFBS3BCIn0=